import { Badge } from '@chakra-ui/react'
import type { InsuranceParamsPagedQuery, InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { defaultDateFrom, ParamsSource } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'

import { useApp } from '@/hooks/useApp'

import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { Card, CardBody, CardTitle } from '../../../components/Card'
import { ConceptsList } from '../../../containers/concepts'
import { useAuth } from '../../../context/AuthContext'
import { useGetAll } from '../../../hooks/useInsuranceParams'
import { conceptsCarsContext } from '../concepts'

function ConceptsWidget({
  query,
  hideIfEmnpty = false
}: {
  query?: InsuranceParamsPagedQuery
  hideIfEmnpty?: boolean
}) {
  const { user } = useAuth()!
  const { product } = useApp()
  const pageSize = 5

  const filter: InsuranceParamsPagedQuery = {
    listType: 1,
    pageIndex: 1,
    dateCreatedFrom: defaultDateFrom,
    pageSize: pageSize,
    ...query
  }

  const { data, mutateAsync, isPending: isLoading } = useGetAll()
  const concepts = data?.data
  const items = concepts?.items ?? []

  useEffect(() => {
    if (!user?.id) return

    mutateAsync(filter)
  }, [user?.id, product])

  if (hideIfEmnpty && items.length === 0)
    return <></>

  return (
    <Card>
      <CardTitle>
        {filter.paramsSource === ParamsSource.AutoRenewed ? 'Automatické nabídky' : 'Neuzavřené nabídky'}
        {!isLoading && items.length > 0 && <Badge>{items.length} / {concepts?.totalCount}</Badge>}
      </CardTitle>

      <CardBody sx={{ p: 0 }}>
        <conceptsCarsContext.Provider value={{ pageSize } as IPaginationContext<InsuranceParamsVehiclePagedQuery>}>
          <ConceptsList concepts={items} loading={isLoading} />
        </conceptsCarsContext.Provider>
      </CardBody>
    </Card>
  )
}

export default ConceptsWidget